const temp_mean = [
-0.1,
-0.13,
-0.17,
-0.2,
-0.24,
-0.26,
-0.27,
-0.27,
-0.26,
-0.25,
-0.25,
-0.26,
-0.27,
-0.26,
-0.24,
-0.23,
-0.21,
-0.18,
-0.17,
-0.17,
-0.2,
-0.23,
-0.26,
-0.28,
-0.31,
-0.34,
-0.36,
-0.37,
-0.39,
-0.41,
-0.41,
-0.39,
-0.35,
-0.32,
-0.31,
-0.3,
-0.3,
-0.3,
-0.3,
-0.3,
-0.28,
-0.27,
-0.26,
-0.24,
-0.23,
-0.22,
-0.22,
-0.21,
-0.2,
-0.19,
-0.19,
-0.18,
-0.17,
-0.16,
-0.15,
-0.13,
-0.1,
-0.06,
-0.01,
0.04,
0.07,
0.09,
0.11,
0.1,
0.08,
0.04,
0.01,
-0.03,
-0.07,
-0.08,
-0.07,
-0.07,
-0.07,
-0.07,
-0.06,
-0.06,
-0.05,
-0.04,
-0.01,
0.01,
0.03,
0.01,
-0.01,
-0.03,
-0.04,
-0.05,
-0.06,
-0.05,
-0.03,
-0.02,
-0.01,
0.0,
0.0,
-0.0,
0.01,
0.02,
0.04,
0.07,
0.12,
0.16,
0.2,
0.21,
0.22,
0.21,
0.21,
0.22,
0.24,
0.27,
0.31,
0.33,
0.33,
0.33,
0.33,
0.33,
0.34,
0.37,
0.4,
0.42,
0.44,
0.47,
0.5,
0.52,
0.55,
0.58,
0.61,
0.62,
0.62,
0.63,
0.64,
0.64,
0.64,
0.66,
0.69,
0.74,
0.78,
0.83,
0.87,
0.91,
0.92,
0.93,
0.93,
0.94,

]

export default temp_mean